module.exports = __webpack_public_path__ + "static/media/polygon.df01d317.svg";